import first from './first'
import second from './second'
import third from './third'
import fourth from './fourth'
import { Diagnosis } from '../hypothesis'

const diagnoses = {
  first,
  second,
  third,
  fourth,
}

/** @type {(key: keyof typeof diagnoses, version: number) => Diagnosis?} */
export function getDiagnosis(key, version) {
  const diagnosesWrapper = diagnoses[key]

  const foundDiagnosis = diagnosesWrapper.find(({ version: diagnosisVersion }) => {
    if (diagnosisVersion.include.length && !diagnosisVersion.include.includes(version)) {
      return false
    }

    if (diagnosisVersion.exclude.length && diagnosisVersion.exclude.includes(version)) {
      return false
    }

    return true
  })

  return foundDiagnosis?.diagnosis ?? null
}
